import { Record } from "immutable";
import moment from "moment";

const defaults = {
    id: undefined,
    brand_id: undefined,
    payment_account_id: undefined,
    currency_code: undefined,
    transaction_date: undefined,
    authorization_amount: undefined,
    transaction_amount: undefined,
    refund_amount: undefined,
    interchange_fee: undefined,
    network_fees: undefined,
    assessment_fee: undefined,
    payfac_fee: undefined,
    chargeback_fee: undefined,
    commission_fee: undefined,
    total_fees: undefined,
    net_amount: undefined,
    all_transaction_count: undefined,
    transactions_with_payment_count: undefined,
    created_on: undefined,
    modified_on: undefined,
};

export class TransactionAggregate extends Record(defaults) {
    declare id: string;
    declare brand_id: string;
    declare payment_account_id: string;
    declare currency_code: string;
    declare transaction_date: moment.Moment;
    declare authorization_amount: number;
    declare transaction_amount: number;
    declare refund_amount: number;
    declare interchange_fee: number;
    declare network_fees: number;
    declare assessment_fee: number;
    declare payfac_fee: number;
    declare chargeback_fee: number;
    declare commission_fee: number;
    declare total_fees: number;
    declare net_amount: number;
    declare all_transaction_count: number;
    declare transactions_with_payment_count: number;
    declare created_on: moment.Moment;
    declare modified_on: moment.Moment;

    constructor(args) {
        super({
            ...args,
            created_on: moment.utc(args.created_on),
            modified_on: moment.utc(args.modified_on),
            transaction_date: moment.utc(args.transaction_date),
            card_expiration_date: moment.utc(args.card_expiration_date),
            processed_date: moment.utc(args.processed_date),
            settlement_date: moment.utc(args.settlement_date),
            fee_settlement_date: moment.utc(args.fee_settlement_date),
            interchange_fee: args.interchange_fee || 0,
            network_fees: args.network_fees || 0,
            assessment_fee: args.assessment_fee || 0,
            payfac_fee: args.payfac_fee || 0,
            chargeback_fee: args.chargeback_fee || 0,
            commission_fee: args.commission_fee || 0,
            refund_amount: args.refund_amount || 0,
        });
    }

    isRefund(): boolean {
        return false;
    }

    getTotalFees(): number {
        return this.total_fees || 0;
    }

    getSettledAmount(): number {
        return this.getNetForDeposit();
    }

    getNetForDeposit(): number {
        return this.net_amount || 0;
    }
    getRefundAmount(): number {
        return this.refund_amount || 0;
    }
}
